export default __webpack_public_path__ + "static/media/octopus.a8121b1f.png";